import PointAndClick from './PointAndClick.js';

import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import { Colors } from '../../consts/Colors.js';


export default class Chapitre5_0 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre5_0"
        })
    }

    init(data){
        this.audioName = 'RewardsOfRisk';
        super.init(data);   
    }

    create(){
        super.create();
            this.background.setTexture('Chapitre5_transition_background');


        // Pas de popup ici

        // On affiche les boutons
        this.displayButtons()
    }

    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "balcon"){
            // Ajout des elements
            this.background.setTexture('Chapitre5_0_background');
            
            let data = this.config.entree
            this.config.boutons.push(data)
            let button = new ButtonDecor(this, data.position.x, data.position.y, 1)
            button.setAlpha(0)
            if(this.chapitreProgression.boutonsDecors[1] == 1){
                button.setViewed();
            }
            this.buttons.push(button)

            button.setClickFunction( (btnInstance) => {
                if(!btnInstance.isViewed){
                    btnInstance.setViewed();
                    this.chapitreProgression.boutonsDecors[btnInstance.id] = 1;
                    this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
                }
                this.openIndice( btnInstance.id );
            } )

            // Ouvre la popup
            this.openIndice(id, data);
        }
    }

    closePopup(){
        let allViewed = true;
        this.buttons.forEach( (btn) => {
            if(!btn.isViewed){
                allViewed = false;
            }
        })
        if(allViewed){
            this.animOut();
        }

        super.closePopup();
    }

    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre5_1")
            }
        })
    }

}